import { ConfigProperties } from "../interfaces/customTypes/configProperties";

export function getReducedConfig(config: ConfigProperties): ConfigProperties {
  return {
    iOSUrl: config.iOSUrl,
    androidUrl: config.androidUrl,
    post: config.post,
    dashboardYoutubeId: config.dashboardYoutubeId,
    firebase: {
      ...config.firebase,
    },
    questions: config.questions,
    questionsLimits: config.questionsLimits,
    stripe: {
      public_key: config.stripe.public_key,
    },
    deployBaseUrl: config.deployBaseUrl,
    defaultComplianceDisclaimer: config.defaultComplianceDisclaimer,
    slugBaseUrl: config.slugBaseUrl,
    randomPrompts: {
      ...config.randomPrompts,
    },
    coachFacebookScopes: config.coachFacebookScopes,
    playerFacebookScopes: config.playerFacebookScopes,
    promptMaxLength: config.promptMaxLength,
    keywordMaxLength: config.keywordMaxLength,
    trialDays: config.trialDays,
    googleAnalyticsId: config.googleAnalyticsId,
    captchaSiteKey: config.captchaSiteKey,
  };
}
